import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import PageHero from "../ones/PageHero";
import servicesHeroBg from "../assets/image12.jpeg"

import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import CustomersBanner from "../ones/CustomersBanner";
import PageWithSidebar from "../components/PageWithSidebar";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
			<PageHero 
                    bgImage={servicesHeroBg}
                    kicker="Huduma Zetu"
                    heading="Mifumo ya Kifedha ya Kidijitali"
                    paragraph="Gundua nguzo zetu kuu nne za kiuchumi zilizoundwa kwa ustadi mkubwa ili kukuza amana zako, kukupatia mikopo nafuu na kukuwezesha kumiliki ushirika wako."
                />
				<PageWithSidebar>
					<ServicesBanner1/>
				</PageWithSidebar>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}
